import {attachStore} from '@eta/components';
import { createStore, applyMiddleware, compose } from 'redux';
import promiseMiddleware from 'redux-promise';
import thunk from 'redux-thunk';
import rootReducers from '../reducers';

const initialState = {};
const middleware = [promiseMiddleware];

const store = createStore(
    rootReducers,
    initialState,
    compose(applyMiddleware(...middleware, thunk))
);
attachStore(store);
export default store;
